import ContentWrapper from "@components/ContentWrapper/ContentWrapper";
import { AiHtmlContent } from "@datassential/platform-ui-lib";
import AiResult from "@vms/AiResult";
import Divider from "@components/Divider";
import Collapsable from "@components/Collapsable";
import { BsStars, BsChevronUp } from "react-icons/bs";
import cn from "classnames";
import "./Test.scss";

const settings = [
    { title: "View As", value: "Brands" },
    { title: "Sort By", value: "Burger King" },
    { title: "Filters", value: "Fruit & Veggies / Fruits" },
    { title: "Display", value: "Love It" },
    { title: "For", value: "Restaurants / Burger King" },
];

const Test = () => {
    return (
        <ContentWrapper className="Test">
            {/* If needed. we can control collapsable by passing defaultShow based on AI answer when some filter changes to hide the content until response is received */}
            <Collapsable defaultShow={true}>
                <Collapsable.Content>
                    <AiResult
                        className="appears-bottom"
                        question="What are the most loved fruits among Burger King visitors? What are the most loved fruits among Burger King visitors?"
                        answer={
                            <AiHtmlContent className="Test__answer" html={`
                                <ul>
                                    <li>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                        Sed fermentum metus turpis, in aliquam ipsum rhoncus eget.
                                        Pellentesque dignissim odio nec ullamcorper venenatis.
                                        Proin varius ornare auctor. Aliquam quis nisl ex.
                                    </li>
                                    <li>
                                        Aenean in tortor at justo ullamcorper tempus sed ut dolor.
                                        Phasellus velit massa, hendrerit eu ex eget,
                                        laoreet dignissim enim. Ut hendrerit feugiat mauris.
                                        Donec malesuada nisl lacus, et mattis risus consequat non.
                                    </li>
                                    <li>
                                        Aenean in tortor at justo ullamcorper tempus sed ut dolor.
                                        Phasellus velit massa, hendrerit eu ex eget,
                                        laoreet dignissim enim. Ut hendrerit feugiat mauris.
                                        Donec malesuada nisl lacus, et mattis risus consequat non.
                                    </li>
                                </ul>
                            `}/>
                        }
                        settings={settings}
                    />
                </Collapsable.Content>
                <Divider className="Test__divider" items={[
                    null,
                    <Collapsable.Control
                        renderLabel={(show) => (
                            <div className="Test__collapse-control">
                                <BsStars className="Test__collapse-ai"/>
                                {show ? "Hide" : "Show"}&nbsp;AI Summary
                                <BsChevronUp className={cn("Test__collapse-icon", show && "is-expanded")}/>
                            </div>
                        )}
                    />
                ]}/>
            </Collapsable>
        </ContentWrapper>
    );
};

export default Test;
